export const CHALLENGES_REGISTERED = 'challengesRegistered';
export const USERS = 'users';
export const CHECKINS = 'checkIns';
